import { render, staticRenderFns } from "./access.vue?vue&type=template&id=3a6bf898&scoped=true"
import script from "./access.vue?vue&type=script&lang=js"
export * from "./access.vue?vue&type=script&lang=js"
import style0 from "./access.vue?vue&type=style&index=0&id=3a6bf898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bf898",
  null
  
)

export default component.exports